import { HEADER_BORDER_WIDTH, HEADER_HEIGHT, SHELL_CONTENT_OFFSET_PX } from "./layout.js";
var HostingEnvironment = /* @__PURE__ */ ((HostingEnvironment2) => {
  HostingEnvironment2["DEVELOPMENT"] = "development";
  HostingEnvironment2["INTEGRATION"] = "integration";
  HostingEnvironment2["STAGING"] = "staging";
  HostingEnvironment2["PRODUCTION"] = "production";
  return HostingEnvironment2;
})(HostingEnvironment || {});
export {
  HEADER_BORDER_WIDTH,
  HEADER_HEIGHT,
  HostingEnvironment,
  SHELL_CONTENT_OFFSET_PX
};
//# sourceMappingURL=index.js.map
